import { Injectable } from '@angular/core';
import { LstEventsService } from '@lst/lst-events';
import { Subject } from 'rxjs';
import {
    EventAction,
    EVENT_NAMESPACE,
    MultiStageReportEventData,
    ResizePagePayload,
} from '../../model/multi-stage-report-event.model';

@Injectable({
    providedIn: 'root',
})
export class EventCommunicationService {
    private readonly handleChildEvents = new Subject<MultiStageReportEventData>();
    private readonly handleParentEvents = new Subject<MultiStageReportEventData>();
    lastHeightPosted = null;

    msdaReportToAssignmentInstance$ = this.lstEventsService.getObservable(
        EVENT_NAMESPACE.MSDA_REPORT_ASSIGNMENT_LISTING,
    );

    msdaReportToMasteryDeepLinkInstace$ = this.lstEventsService.getObservable(
        EVENT_NAMESPACE.MSDA_REPORT_MASTERY_DEEP_LINK,
    );

    msdaReportToGrowthReportInstance$ = this.lstEventsService.getObservable(
        EVENT_NAMESPACE.MSDA_REPORT_MSDA_GROWTH_REPORT
    );

    assessmentToMsdaReportInstance$ = this.lstEventsService.getObservable(EVENT_NAMESPACE.ASSESSMENT_MSDA_REPORT);
    searchViewerInstance$ = this.lstEventsService.getObservable(EVENT_NAMESPACE.MSDA_REPORT_SEARCH_VIEWER);

    handleChildEvents$ = this.handleChildEvents.asObservable();
    handleParentEvents$ = this.handleParentEvents.asObservable();

    constructor(private readonly lstEventsService: LstEventsService) {}

    handleChildEvent(event: MultiStageReportEventData): void {
        this.handleChildEvents.next(event);
    }

    handleParentEvent(event: MultiStageReportEventData): void {
        this.handleParentEvents.next(event);
    }

    sendEventToParent(event: MultiStageReportEventData): void {
        this.lstEventsService.publishData(event, this.msdaReportToAssignmentInstance$);
        this.lstEventsService.publishData(event, this.msdaReportToMasteryDeepLinkInstace$);
        this.lstEventsService.publishData(event, this.msdaReportToGrowthReportInstance$);
    }

    sendResizePageMessageToParent(): void {
        const body = document.body,
            html = document.documentElement;

        const height = Math.max(body.scrollHeight, body.offsetHeight, body.clientHeight, html.offsetHeight);

        if (this.lastHeightPosted !== height) {
            const payload: ResizePagePayload = {
                resize_height: height,
            };
            this.sendEventToParent({ action: EventAction.RESIZE_PAGE, payload });
            this.lastHeightPosted = height;
        }
    }

    sendEventToSearchViewer(data: MultiStageReportEventData): void {
        this.lstEventsService.publishData(data, this.searchViewerInstance$);
    }

}
